import { createElement } from "../components/LayoutEditor/drawUtils";
import { isColliding } from "../components/LayoutEditor/geometryutils";
import { saveWarehouse } from "../utils/storageUtil";
// import antd notification
import { notification } from "antd";

const actionHandlers = {

  LOAD_BINFORM: (state, action) => {
    return {
      ...state,
      loadBinForm: action.payload
    };
  },

  SET_TOOL: (state, action) => {
    return {
      ...state,
      layoutEditor: {
        ...state.layoutEditor,
        tool: action.payload,
      },
    };
  },
  SET_ACTION: (state, action) => {
    return {
      ...state,
      layoutEditor: {
        ...state.layoutEditor,
        action: action.payload,
      },
    };
  },
  SET_PAN_OFFSET: (state, action) => {
    return {
      ...state,
      layoutEditor: {
        ...state.layoutEditor,
        panOffset: action.payload,
      },
    };
  },
  SET_ZOOM: (state, action) => {
    return {
      ...state,
      layoutEditor: {
        ...state.layoutEditor,
        zoom: action.payload,
      },
    };
  },
  SET_ZOOM_CENTER: (state, action) => {
    return {
      ...state,
      layoutEditor: {
        ...state.layoutEditor,
        zoomCenter: action.payload,
      },
    };
  },
  SET_SCALED_OFFSET: (state, action) => {
    return {
      ...state,
      layoutEditor: {
        ...state.layoutEditor,
        scaledOffset: action.payload,
      },
    };
  },
  SET_CANVAS_DIMENSIONS: (state, action) => {
    return {
      ...state,
      layoutEditor: {
        ...state.layoutEditor,
        canvasDimensions: action.payload,
      },
    };
  },
  SET_SELECTED_ELEMENT: (state, action) => {
    return {
      ...state,
      layoutEditor: {
        ...state.layoutEditor,
        selectedElement: action.payload,
      },
    };
  },
  SET_START_PAN_MOUSE_POSITION: (state, action) => {
    return {
      ...state,
      layoutEditor: {
        ...state.layoutEditor,
        startPanMousePosition: action.payload,
      },
    };
  },
  SET_ELEMENTS: (state, action) => {
    // sort elements based on priority of zone > area > wall > rack > dock
    // and update zIndex to each element in the array 
    const sortedElements = action.payload.sort((a, b) => {
      const priority = { zone: 0, area: 1, wall: 2, rack: 3, dock: 4 };
      return priority[a.objectType] - priority[b.objectType];
    }).map((element, index) => ({ ...element, zIndex: index }));
    return {
      ...state,
      elements: sortedElements,
    };
  },
  SET_INITIAL_LOAD: (state, action) => {
    return {
      ...state,
      initialLoad: action.payload,
    };
  },
  CLEAR_ELEMENTS: (state, action) => {
    return {
      ...state,
      elements: [],
    };
  },

  SET_VIEWPORT_MODE: (state, action) => {
    return {
      ...state,
      viewportMode: action.payload,
    };
  },

  BATCH_DISPATCH: (state, action) => {
    const { payload } = action;
    if (Array.isArray(payload)) {
      return payload.reduce((currentState, currentAction) => {
        const newState = actionHandlers[currentAction.type](currentState, currentAction);
        return { ...newState };
      }, state);
    }
    return state;
  },
  SAVE_WAREHOUSE: (state, action) => {
    const {
      payload: { warehouseName, elements },
    } = action;
    const cachedWarehouses = state.warehouses || [];
    const index = cachedWarehouses.findIndex((warehouse) => warehouse.warehouseName === warehouseName);
    if (index > -1) {
      cachedWarehouses[index] = {
        warehouseName,
        elements,
      };
    } else {
      cachedWarehouses.push({
        warehouseName,
        elements,
      });
    }
    return {
      ...state,
      warehouse: action.payload.warehouseName,
      warehouses: cachedWarehouses,
    };
  },
  SET_WAREHOUSE: (state, action) => {
    const { payload: warehouseName } = action;
    const cachedWarehouses = state.warehouses || [];
    const warehouse = cachedWarehouses.find((warehouse) => warehouse.name === warehouseName);
    if (!warehouse) return state;
    return {
      ...state,
      warehouse: warehouseName,
      //elements: warehouse.elements
    };
  },
  SET_WAREHOUSES: (state, action) => {
    const warehouses = action.payload;
    if (warehouses.length === 0) return state;
    return {
      ...state,
      //   warehouse: warehouses[0].warehouseName,
      warehouses: warehouses,
      //elements: warehouses[0].elements
    };
  },
  REMOVE_ELEMENT: (state, action) => {
    const { payload: element } = action;
    const _elements = state.elements.filter((e) => e.id !== element.id);
    return {
      ...state,
      elements: _elements,
      selectedElement: null,
    };
  },
  ADD_ELEMENT: (state, action) => {
    const { payload: element } = action;

    return {
      ...state,
      elements: [...state.elements, { ...element, hasElementChanges: true }],
    };
  },
  UPDATE_ELEMENT: (state, action) => {
    const { payload: element } = action;

    const index = state.elements.findIndex((e) => e.id === element.id);
    if (index > -1) {
      const updatedElements = [...state.elements];
      updatedElements[index] = {
        ...updatedElements[index],
        ...element,
        hasElementChanges: true,
      };

      // Synchronize selection states
      const isSelectedInLayoutEditor = state.layoutEditor?.selectedElement?.id === element.id;
      const isSelectedInVisualizer = state.selectedElement?.id === element.id;

      let newState = {
        ...state,
        elements: updatedElements,
      };

      if (isSelectedInLayoutEditor) {
        newState.layoutEditor = {
          ...state.layoutEditor,
          selectedElement: updatedElements[index],
        };
      }

      if (isSelectedInVisualizer) {
        newState.selectedElement = updatedElements[index];
      }

      return newState;
    }
    return state;
  },
  REPLACE_ELEMENT: (state, action) => {
    const {
      payload: { elementIndex, data },
    } = action;

    if (elementIndex > -1) {
      const updatedElements = [...state.elements];
      updatedElements[elementIndex] = {
        ...updatedElements[elementIndex],
        ...data,
        hasElementChanges: true,
      };

      const selectedId = state.layoutEditor?.selectedElement?.id;
      const updatedSelectedElement = selectedId === updatedElements[elementIndex].id 
        ? updatedElements[elementIndex] 
        : state.layoutEditor.selectedElement;

      return {
        ...state,
        elements: updatedElements,
        layoutEditor: {
          ...state.layoutEditor,
          selectedElement: updatedSelectedElement,
        },
      };
    }
    return state;
  },
  SET_FULLSCREEN_MODE_ENABLED: (state, action) => {
    return {
      ...state,
      FULLSCREEN_MODE_ENABLED: action.payload
    }
  },
  SHOW_GLOBAL_LOADER: (state, action) => {
    return {
      ...state,
      globalLoader: action.payload
    }
  },
  HIDE_GLOBAL_LOADER: (state, action) => {
    return {
      ...state,
      globalLoader: {
        isActive: false,
        loaderText: "Loading",
      }
    }
  },

  SET_GLOBAL_SHOW_LOCATION: (state, action) => {
    return {
      ...state,
      globalShowLocation: action.payload
    }
  },
  RE_SET_TOOL: (state, action) => {
    return {
      ...state,
      rackEditor: {
        ...state.rackEditor,
        tool: action.payload
      }
    }
  },
  RE_SET_ACTION: (state, action) => {
    return {
      ...state,
      rackEditor: {
        ...state.rackEditor,
        action: action.payload,
      },
    };
  },
  RE_SET_CANVAS_DIMENSIONS: (state, action) => {
    return {
      ...state,
      rackEditor: {
        ...state.rackEditor,
        canvasDimensions: action.payload,
      },
    };
  },
  RE_SET_PAN_OFFSET: (state, action) => {
    return {
      ...state,
      rackEditor: {
        ...state.rackEditor,
        panOffset: action.payload,
      },
    };
  },
  RE_SET_ZOOM: (state, action) => {
    return {
      ...state,
      rackEditor: {
        ...state.rackEditor,
        zoom: action.payload,
      },
    };
  },
  RE_SET_ZOOM_CENTER: (state, action) => {
    return {
      ...state,
      rackEditor: {
        ...state.rackEditor,
        zoomCenter: action.payload,
      },
    };
  },
  RE_SET_SCALED_OFFSET: (state, action) => {
    return {
      ...state,
      rackEditor: {
        ...state.rackEditor,
        scaledOffset: action.payload,
      },
    };
  },
  RE_SET_SELECTED_ELEMENT: (state, action) => {
    return {
      ...state,
      rackEditor: {
        ...state.rackEditor,
        selectedElement: action.payload,
      },
    };
  },
  RE_SET_START_PAN_MOUSE_POSITION: (state, action) => {
    return {
      ...state,
      rackEditor: {
        ...state.rackEditor,
        startPanMousePosition: action.payload,
      },
    };
  },
  RE_SET_LAYOUT: (state, action) => {
    return {
      ...state,
      layout: action.payload,
    };
  },
  RE_SET_ELEMENTS: (state, action) => {
    return {
      ...state,
      rackEditor: {
        ...state.rackEditor,
        elements: action.payload,
      }
    };
  },
  RE_SET_SELECTED_ELEMENT: (state, action) => {
    return {
      ...state,
      rackEditor: {
        ...state.rackEditor,
        selectedElement: action.payload,
      },
    };
  },
  RE_UPDATE_ELEMENT: (state, action) => {
    const { payload: element } = action;
    const index = state.rackEditor.elements.findIndex((e) => e.id === element.id);
    if (index > -1) {
      state.rackEditor.elements[index] = {
        ...state.rackEditor.elements[index],
        ...element,
      };

      if (!element?.hasElementChanges) {
        state.rackEditor.elements[index] = {
          ...state.rackEditor.elements[index],
          hasElementChanges: true,
        };
      }

      return {
        ...state,
        rackEditor: {
          ...state.rackEditor,
          elements: [...state.rackEditor.elements],
          selectedElement: state.rackEditor.elements[index],
        },
      };
    }
    return state;
  },
  RE_REMOVE_ELEMENT: (state, action) => {
    const { payload: element } = action;
    const _elements = state.rackEditor.elements.filter((e) => e.id !== element.id);
    return {
      ...state,
      rackEditor: {
        ...state.rackEditor,
        elements: _elements,
        selectedElement: null,
      },
    };
  },

  // Actions for 3d editor
  // Created from DW:2.0 development
  SELECTED_ELEMENT: (state, action) => {
    return {
      ...state,
      selectedElement: action.payload,
    };
  },
  UPDATE_BINS: (state, action) => {
    return {
      ...state,
      selectedElement: {
        ...state.selectedElement,
        bins: action.payload.bins,
      },
      elements: state.elements.map((element) => {
        if (element.id === action.payload.id) {
          element.bins = action.payload.bins;
          return element;
        }
        return element;
      })
    }
  },
  UPDATE_SUBAREAS: (state, action) => {
    return {
      ...state,
      selectedElement: {
        ...state.selectedElement,
        subAreas: action.payload.subAreas,
      },
      elements: state.elements.map((element) => {
        if (element.id === action.payload.id) {
          element.subAreas = action.payload.subAreas;

          return element;
        }
        return element;
      })
    }
  },
  UPDATE_LAYOUT_OBJECT: (state, action) => {
    const { id, layoutObject } = action.payload;
    const updatedElements = state.elements.map((element) => {
      if (element.id === id) {
        let updated = { ...layoutObject };
        if (element.objectType === 'rack') {
          updated.bins = element.bins;
        } else if (element.objectType === 'area') {
          updated.subAreas = element.subAreas; // Note: was misspelled as subareas in original
        }
        return updated;
      }
      return element;
    });

    const isSelectedInLayoutEditor = state.layoutEditor?.selectedElement?.id === id;
    const isSelectedInVisualizer = state.selectedElement?.id === id;

    let newState = {
      ...state,
      elements: updatedElements,
    };

    if (isSelectedInLayoutEditor) {
      newState.layoutEditor = {
        ...state.layoutEditor,
        selectedElement: updatedElements.find((e) => e.id === id),
      };
    }

    if (isSelectedInVisualizer) {
      newState.selectedElement = updatedElements.find((e) => e.id === id);
    }

    return newState;
  },
};

export default function reducer(state = {}, action) {
  const actionToRun = actionHandlers[action.type] || (() => state);
  return actionToRun(state, action);
}
